<template>
    <div
        v-if="dailyCoral && dailyCoral.id"
        id="home-daily"
        style="margin-top: 10px"
    >
        <h2 style="padding-top: 26px;">Your daily Coral</h2>
        <f7-block
            class="homeBlock"
            style="margin-bottom: 16px"
        >
            <sequential-entrance
                from-bottom
                delay="400"
            >
                <unit-card
                    :unit="dailyCoral"
                    :visible="true"
                    :is-learn="true"
                    :is-daily-coral="true"
                    :home="true"
                    :class="`last`"
                    :disabled="false"
                    :index="0"
                    :pack="[dailyCoral]"
                />
            </sequential-entrance>
        </f7-block>
    </div>
</template>

<script>
import UnitCard from '../../components/unitCard.vue';

export default {
    components: {
        UnitCard,
    },
    props: ['dailyCoral'],
    store: ['api', 'user', 'unitsIndex', 'topicsIndex'],
    data () {
        return {
        };
    },
    watch: {},
    mounted: function () {

    },
    methods: {

    }
};
</script>


<style lang="less" scoped>
@import '../../css/colors.less';

.center {
    text-align: center;
}
h2 {
    color: white;
    position: relative;
    z-index: 15;
    text-align: left;
    font-family: Editor-Bold;
    font-size: 21px;
    line-height: 26px;
    margin: 0 0 8px;
}
.blockTitle {
    margin-left: 0;
    color: white;
    font-family: AndesMedium;
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 15px;
    z-index: 15;
    position: relative;
    margin-bottom: 4px;
}
.courseDescription {
    margin-top: -4px;
    color: white;
    font-family: AndesLight;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    padding-bottom: 12px;
    z-index: 15;
    position: relative;
}
.moreLink {
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    color: #d9ccc4;
}
.nextLink {
    color: white;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 64px;
    z-index: 15px;
    position: relative;
    z-index: 16;
}
.home-scroll {
    margin-top: -100px !important;
    padding-top: 100px !important;
    height: ~'calc(100% + 100px)' !important;
    max-height: ~'calc(100% + 200px)' !important;
}
.homeBlockWrapper {
    text-align: left;
    transition: background-color 1s;
    color: white;
    background-size: 100% auto;
    background-position: bottom left;
    background-repeat: no-repeat;
    margin-bottom: 0px;
    padding-bottom: 20px;
}
.homeBlock {
    max-width: 100vw;
    background: white;
    padding: 0px;
    margin: 0px 0px 0px;
    border-radius: 13px;
    z-index: 15;
    position: relative;
}
.theme-dark .homeBlock {
    background: @black;
}
</style>
